import { render, staticRenderFns } from "./SendFileWithArchiveStoreModal.vue?vue&type=template&id=97317e04&scoped=true"
import script from "./SendFileWithArchiveStoreModal.vue?vue&type=script&lang=ts"
export * from "./SendFileWithArchiveStoreModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97317e04",
  null
  
)

export default component.exports